import React from "react";
import logo from "../../assets/images/podcast.jpg";
import industry from "../../assets/images/industry.jpg";
import { useNavigate } from "react-router-dom";
export default function WareHouseIndustry() {
  const navigate = useNavigate();
  const handlePodcastList = () => {
    navigate("/warehouse/leaders-in-the-industry/podcast-listing");
  };
  const handleIndustryListing = () => {
    navigate("/warehouse/leaders-in-the-industry/industry-news-listing");
  };
  const handlepodcastdetail = (podcast) => {
    navigate(`/warehouse/leaders-in-the-industry/podcast-detail`, {
      state: { podcast }, // Pass full topic object
    });
  };

  const handleIndustrydetail = (news) => {
    navigate(`/warehouse/leaders-in-the-industry/industry-news-detail`, {
      state: { news }, // Pass full topic object
    });
  };

  const partners = [
    {
      name: "Podcast 1",
      sector: "AI Technology",
      logo: "https://via.placeholder.com/250", // Replace with actual image URL
    },
    {
      name: "Podcast 2",
      sector: "Customer Service",
      logo: "https://via.placeholder.com/250", // Replace with actual image URL
    },
    {
      name: "Podcast 3",
      sector: "Automation",
      logo: "https://via.placeholder.com/250", // Replace with actual image URL
    },
    {
      name: "Podcast 4",
      sector: "Automation",
      logo: "https://via.placeholder.com/250", // Replace with actual image URL
    },
  ];
  const news = [
    {
      name: "Industry news 1",
      sector: "AI Technology",
      logo: "https://via.placeholder.com/250", // Replace with actual image URL
    },
    {
      name: "Industry news 2",
      sector: "Customer Service",
      logo: "https://via.placeholder.com/250", // Replace with actual image URL
    },
    {
      name: "Industry news 3",
      sector: "Automation",
      logo: "https://via.placeholder.com/250", // Replace with actual image URL
    },
    {
      name: "Industry news 4",
      sector: "Automation",
      logo: "https://via.placeholder.com/250", // Replace with actual image URL
    },
  ];

  return (
    <div className="my-4 mx-2">
      {/* Main Section - Video + Text */}
      <div className="card shadow-lg border-0">
        <div className="card-body p-4 ">
          <h2>
            <strong> Podcast</strong>
          </h2>
          <div className="row align-items-center">
            {/* Left Side - Text */}
            <div className="col-md-6 text-start main-heading">
              <h2>Small Business</h2>
              <p>
                Connect all your data, with all your teams, all on one
                integrated, AI-driven platform. Get started today with Starter
                Suite, the all-in-one CRM app for small business. Scale
                seamlessly, however large you grow.Connect all your data, with
                all your teams, all on one integrated, AI-driven platform. Get
                started today with Starter Suite, the all-in-one CRM app for
                small business. Scale seamlessly, however large you grow.
              </p>
            </div>
            {/* Right Side - Video */}
            <div className="col-md-6 d-flex justify-content-center">
              <div
                className="ratio ratio-16x9"
                style={{ width: "80%", height: "300px" }}
              >
                <iframe
                  src="https://www.youtube.com/embed/TqrjeXTZkVA?si=rVJvEEtFvrxQP9jq"
                  title="Podcast Industry Video"
                  allowFullScreen
                  className="rounded"
                ></iframe>
              </div>
            </div>
          </div>
          <div
            className="row mt-4 main-card-leaders "
            style={{ display: "flex", justifyContent: "center" }}
          >
            <h2 className="text-center my-4">Podcasts </h2>
            {partners.map((partner, index) => (
              <div key={index} className="col-md-3 col-sm-6 col-12 mb-3">
                <div className="card d-flex flex-column h-100 shadow-sm">
                  {/* Card Image */}
                  <img
                    onClick={() => handlepodcastdetail(partner)}
                    style={{ cursor: "pointer" }}
                    src={logo}
                    alt={partner.name}
                    className="card-img-top p-0"
                  />

                  {/* Card Content (Full Height) */}
                  <div className="card-body flex-grow-1 d-flex flex-column justify-content-end card-content-partners">
                    <h5
                      onClick={() => handlepodcastdetail(partner)}
                      className="card-title mb-1"
                    >
                      {partner.name}
                    </h5>
                    <p className="card-text mb-0"></p>
                  </div>
                </div>
              </div>
            ))}
            <div className="text-end mt-1">
              <button
                onClick={handlePodcastList}
                className="small-button-cotain-view-all"
              >
                View all
              </button>
            </div>{" "}
          </div>
        </div>
      </div>
      <div className="card shadow-lg border-0 mt-4">
        <div className="card-body p-4">
          <h2>
            <strong> Industry News</strong>
          </h2>
          <div className="row align-items-center">
            {/* Left Side - Text */}
            <div className="col-md-6 text-start main-heading">
              <h2>Connect all your data </h2>
              <p>
                Connect all your data, with all your teams, all on one
                integrated, AI-driven platform. Get started today with Starter
                Suite, the all-in-one CRM app for small business. Scale
                seamlessly, however large you grow.Connect all your data, with
                all your teams, all on one integrated, AI-driven platform. Get
                started today with Starter Suite, the all-in-one CRM app for
                small business. Scale seamlessly, however large you grow.
              </p>
            </div>
            {/* Right Side - Video */}
            <div className="col-md-6 d-flex justify-content-center">
              <div
                className="ratio ratio-16x9"
                style={{ width: "80%", height: "300px" }}
              >
                {" "}
                <iframe
                  src="https://www.youtube.com/embed/TqrjeXTZkVA?si=rVJvEEtFvrxQP9jq"
                  title="Podcast Industry Video"
                  allowFullScreen
                  className="rounded"
                ></iframe>
              </div>
            </div>
          </div>
          <div
            className="row mt-4 main-card-leaders "
            style={{ display: "flex", justifyContent: "center" }}
          >
            <h2 className="text-center my-4">Industry News </h2>
            {news.map((partner, index) => (
              <div key={index} className="col-md-3 col-sm-6 col-12 mb-3">
                <div className="card d-flex flex-column h-100 shadow-sm">
                  {/* Card Image */}
                  <img
                    onClick={() => handleIndustrydetail(partner)}
                    style={{ cursor: "pointer" }}
                    src={industry}
                    alt={partner.name}
                    className="card-img-top p-0"
                  />

                  {/* Card Content (Full Height) */}
                  <div className="card-body flex-grow-1 d-flex flex-column justify-content-end card-content-partners">
                    <h5
                      onClick={() => handleIndustrydetail(partner)}
                      className="card-title mb-1"
                    >
                      {partner.name}
                    </h5>
                    <p className="card-text mb-0"></p>
                  </div>
                </div>
              </div>
            ))}
            <div className="text-end  mt-1">
              <button
                onClick={handleIndustryListing}
                className="small-button-cotain-view-all"
              >
                View all
              </button>
            </div>{" "}
          </div>
        </div>
      </div>
      {/* 3 Cards Section */}
    </div>
  );
}
